import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog'
import { NgxCaptchaModule } from 'ngx-captcha';

import { LzLogModule } from "../lz-log/lz-log.module";

import { LzFeedbackComponent } from './components/feedback/lz-feedback.component';

import { LzFeedbackService } from './services/lz-feedback.service';

@NgModule({
  declarations: [
    LzFeedbackComponent
  ],
  providers: [
    LzFeedbackService,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    TranslateModule,
    MatDialogModule,

    ReactiveFormsModule,
    NgxCaptchaModule.forRoot(),
    LzLogModule
  ],
  entryComponents: [
    LzFeedbackComponent
  ]
})

export class LzFeedbackModule { }

